"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    accessible: _propTypes.PropTypes.bool,
    theme: _propTypes.PropTypes.string,
    currencyFormat: _propTypes.PropTypes.string,
    currency: _propTypes.PropTypes.string,
    locale: _propTypes.PropTypes.string,
    totalAmount: _propTypes.PropTypes.number.isRequired,
    bgColor: _propTypes.PropTypes.string,
    productImgHeight: _propTypes.PropTypes.string,
    productImgWidth: _propTypes.PropTypes.string,
    bookingDetails: _propTypes.PropTypes.shape({
      title: _propTypes.PropTypes.string.isRequired,
      imageUrl: _propTypes.PropTypes.string,
      validTill: _propTypes.PropTypes.string
    }).isRequired,
    translation: _propTypes.PropTypes.shape({
      totalPayment: _propTypes.PropTypes.string,
      validUntil: _propTypes.PropTypes.string
    })
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    currencyFormat: _constant2.DEFAULT_CURRENCY_FORMAT,
    currency: _constant2.DEFAULT_CURRENCY,
    locale: _constant2.DEFAULT_LOCALE,
    bgColor: _constant2.DEFAULT_BG_COLOR,
    productImgHeight: _constant2.DEFAULT_PRODUCT_IMG_HEIGHT,
    productImgWidth: _constant2.DEFAULT_PRODUCT_IMG_WIDTH,
    translation: _constant2.DEFAULT_TRANSLATION
  }
};
exports.default = _default;